import { Grid } from "@mui/material";
import { showBasicInfo, updateShowViewCount } from "../../api";
import './recent-shows.css'
import { useNavigate } from "react-router-dom";

export interface RecentShowsProps {
    shows: showBasicInfo[];
}

const RecentShows = ({shows}: RecentShowsProps) => {
    let navigate = useNavigate();
    const first12Shows = shows.slice(0, 12);

    const clickHandler = (id: string) => {
        updateShowViewCount(id, null);
        navigate(`/imdb/${id}`);
    }

    return (
        <>
        <div className="recentShowsWrapper">
            <h6>Recently Viewed</h6>
            <Grid container spacing={5}>
            {first12Shows?.map((show) => 
                <Grid xs={3} sm={2} key={show.id} onClick={() => clickHandler(show.id)}>
                    <div className="recentShow">
                        <img src={show.coverImage} alt={show.title} title={show.title} className="searchResultImage" />
                    </div>
                </Grid>
            )}
            </Grid>
        </div>
        </>
    );
}

export default RecentShows;